import { getPlayBookDetail } from '@Store/feature/playBookDetailSlice';
import { useAppSelector } from '@Store/hooks';
import moment from 'moment';
import React, { FC } from 'react';
import { getTaskColor } from '../helper';

type IProps = {
  data: any;
};

const CountdownCel: FC<IProps> = ({ data }) => {
  const { dealTaskList } = useAppSelector(getPlayBookDetail);
  const currentDay =
    new Date().getFullYear() +
    '-' +
    (new Date().getMonth() + 1) +
    '-' +
    ('0' + new Date().getDate()).slice(-2);

  let earlyDiff = data.data.data.dueDate
    ? moment(currentDay).diff(
        moment(data.data.data.dueDate.split('T')[0]),
        'days'
      )
    : -1;

  let lateDiff = data.data.data.dueDate
    ? moment(data.data.data.dueDate.split('T')[0]).diff(
        moment(currentDay),
        'days'
      )
    : -1;

  return (
    <div
      style={{
        color: getTaskColor(data.data.data, dealTaskList),
        width: 'auto',
        fontSize: 11,
        fontFamily: 'Inter',
        marginRight: 35,
        minWidth: 100,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {data.data.text && !data.data.data.isCompleted ? (
        <span>
          {earlyDiff === 0
            ? 'Due today'
            : new Date() < new Date(data.data.data.dueDate)
            ? lateDiff + (lateDiff > 1 ? ' days' : ' day') + ' to go'
            : earlyDiff + (earlyDiff > 1 ? ' days' : ' day') + ' overdue'}
        </span>
      ) : (
        <div></div>
      )}
      <span></span>
    </div>
  );
};

export default CountdownCel;
